<div class="mb-5">
  <h3 class="textTabsColor mb-3 text-sm font-bold">{{ isArabic() ? "صنف ثلاجة" : "Refrigerator Product" }}</h3>
  <div class="flex w-48 items-center gap-3 rounded-lg border border-gray-200 bg-gray-50 px-4 py-3">
    <label class="relative inline-flex cursor-pointer items-center">
      <input type="checkbox" [checked]="value()" (change)="onChange($event)" class="peer sr-only" />
      <div
        class="peer peer-checked-bg-primary h-5 w-9 rounded-full bg-gray-300 transition-colors after:absolute after:top-[2px] after:left-[2px] after:h-4 after:w-4 after:rounded-full after:bg-white after:transition-all peer-checked:after:translate-x-full"></div>
    </label>
    <span class="text-sm font-medium text-gray-700">{{ isArabic() ? "صنف ثلاجة" : "Refrigerator Product" }}</span>
  </div>
</div>
